import React, { useEffect, useState } from 'react';
import useTabQueryParam from '../../hooks/useTabQueryParam';
import { useNavigate } from 'react-router-dom';
import Table from '../../components/Table';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_ENDPOINT;

const leaveTypeMap = {
  1: 'Personal Leave',
  2: 'Sick Leave',
  3: 'Work from Home',
};

const columns = [
  { key: 'leaveType', title: 'Leave Policy Name' },
  { key: 'carryForwardType', title: 'Carry Forward Type' },
  { key: 'maxDays', title: 'Max Days' },
  { key: 'carryForward', title: 'Carry Forward' },
  { key: 'carryForwardDays', title: 'Carry Forward Days' },
];

const LeavePolicy = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editPolicy, setEditPolicy] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API_BASE}/api/accounts/company/leave-policy/`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
    })
      .then(res => {
        setData(res.data.map(policy => ({
          id: policy.id,
          leaveType: leaveTypeMap[policy.leave_type] || policy.leave_type,
          carryForwardType: policy.carry_forward_type,
          maxDays: policy.max_days,
          carryForward: policy.carry_forward ? 'Yes' : 'No',
          carryForwardDays: policy.carry_forward_days,
        })));
      })
      .finally(() => setLoading(false));
  }, []);

  const openModal = (policy = null) => {
    setEditPolicy(policy);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setEditPolicy(null);
  };

  const handleDelete = (policy) => {
    // TODO: Implement delete logic (API call)
    alert('Delete not implemented yet');
  };

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useTabQueryParam('tab', 'leave-policy');
  const TABS = [
    { key: 'members', label: 'Members', route: '' },
    { key: 'leave-policy', label: 'Leave Policy', route: 'leave-policy' },
    { key: 'holidays', label: 'Holidays', route: 'holidays' },
  ];

  const handleTabClick = (tabKey, route) => {
    setActiveTab(tabKey);
    navigate(`/company/${route}`);
  };

  return (
    <div>

      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold">Leave Policies</h2>
        <button className="bg-indigo-600 text-white px-4 py-2 rounded font-semibold" onClick={() => openModal()}>Add Leave Policy</button>
      </div>
      <Table columns={columns} data={data} actions={row => (
        <>
          <button className="bg-yellow-500 hover:bg-yellow-600 text-white px-2 py-1 rounded mr-2" title="Edit" onClick={() => openModal(row)}><i className="fas fa-edit" /></button>
          <button className="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded" title="Delete" onClick={() => handleDelete(row)}><i className="fas fa-trash" /></button>
        </>
      )} />
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 shadow-xl min-w-[320px]">
            <h3 className="text-lg font-bold mb-4">{editPolicy ? 'Edit Leave Policy' : 'Add Leave Policy'}</h3>
            {/* Modal form fields go here */}
            <div className="flex gap-4 mt-6">
              <button className="bg-indigo-600 text-white px-4 py-2 rounded" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
      {loading && <div className="text-center py-8">Loading...</div>}
    </div>
  );
};

export default LeavePolicy;
